import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { QRCodeSVG } from 'qrcode.react';

import appleDownload from 'static/img/AppStores/download-on-app-store.png';
import googleDownload from 'static/img/AppStores/get-it-on-google-play.png';

import Button from 'components/Button';
import { CardSection } from 'components/Card';
import Message from 'components/Message';

import { bem } from 'helpers/class-name';
import { ICONS } from 'constants/icons';

import { messages } from './MFASetupModal.messages';

const { element } = bem('mfa-setup-modal');

export const APP_STORE_URLS = {
  GOOGLE_AUTHENTICATOR: {
    APPLE: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
    GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
  },
};

export const QR_CODE_CONFIG = {
  SIZE: 180,
  MARGIN_SIZE: 4,
};

const QRCodeReadStep = ({ privateKey, qrcodeURI, onCopyToClipboard, onContinue }) => (
  <>
    <CardSection flush>
      <Message as="p" className={element('step-title')} message={messages.step1} />
      <div className={element('download-options')}>
        <a href={APP_STORE_URLS.GOOGLE_AUTHENTICATOR.APPLE} target="_blank" rel="noopener noreferrer">
          <img src={appleDownload} alt="Download on the App Store" />
        </a>
        <a href={APP_STORE_URLS.GOOGLE_AUTHENTICATOR.GOOGLE_PLAY} target="_blank" rel="noopener noreferrer">
          <img src={googleDownload} alt="Get it on google play" />
        </a>
      </div>
    </CardSection>
    <CardSection flush>
      <Message as="p" className={element('step-title')} message={messages.step2} />
      <Message className={element('info-text')} message={messages.infoText} />
      <div className={element('qr-code-container')}>
        <QRCodeSVG value={qrcodeURI} size={QR_CODE_CONFIG.SIZE} marginSize={QR_CODE_CONFIG.MARGIN_SIZE} />
      </div>
    </CardSection>
    <CardSection className={element('copy-key-container')} flush>
      <button className={element('copy-key-btn')} onClick={onCopyToClipboard} type="button">
        {privateKey}
        <Isvg className={element('copy-key-icon')} src={ICONS.copy2} />
      </button>
      <Message className={element('key-type-info')} message={messages.keyTypeInfo} />
    </CardSection>
    <Button styled="primary" onClick={onContinue} type="button">
      <Message message={messages.continue} />
    </Button>
  </>
);

QRCodeReadStep.propTypes = {
  privateKey: PropTypes.string.isRequired,
  qrcodeURI: PropTypes.string.isRequired,
  onCopyToClipboard: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default QRCodeReadStep;
